import { render, staticRenderFns } from "./PropertyTax.vue?vue&type=template&id=1ada1a8a&"
import script from "./PropertyTax.vue?vue&type=script&lang=js&"
export * from "./PropertyTax.vue?vue&type=script&lang=js&"
import style0 from "./propertyTaxForm.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports